class AnticorruptionApi {
  constructor(
    setpoint,
    returnData,
    supply,
    ambientData,
    powerStatus,
    engineControlMode,
    fuelLevel,
    dataTimeStampData,
    engineHours,
  ) {
    this.setpointApi = setpoint;
    this.returnApi = returnData;
    this.supplyApi = supply;
    this.ambientApi = ambientData;
    this.powerStatusApi = powerStatus;
    this.engineControlModeApi = engineControlMode;
    this.fuelLevelApi = fuelLevel;
    this.dateTimestampApi = dataTimeStampData;
    this.engineHoursApi = engineHours;
  }
}

module.exports = { AnticorruptionApi };
